let isStyled = false;
const animationName = 'resize-animation';

let requestFrame = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRuestAnimationFrame || function(fn){
    return setTimeout(fn, 20)
  }

let cancelFrame = window.cancelAnimationFrame ||
  window.webkitCancelAnimationFrame ||
  window.mozCancelAnimation ||
  function(id){
    return clearTimeout(id)
  };
var animationstartevent = null;
function setStyle(){
  if(isStyled){
    return;
  }
    /* Detect CSS Animations support to detect element display/re-attach */
  var animation = false,
    keyframeprefix = '',
    domPrefixes = 'Webkit Moz O ms'.split(' '),
    startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
    pfx = '';
    // 确定是否支持css动画及css前缀
  var elm = document.createElement('fakeelement');
  if(elm.style.animationName !== undefined) { animation = true; }

  if(animation === false) {
    for(var i = 0; i < domPrefixes.length; i++) {
      if(elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined) {
        pfx = domPrefixes[ i ];
        keyframeprefix = '-' + pfx.toLowerCase() + '-';
        animationstartevent = startEvents[ i ];
        animation = true;
        break;
      }
    }
  }
    // 定义css动画名称及对应动画效果声明
  var animationName = 'resizeanim';
  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';

  let css = `${animationKeyframes}
    .resize-triggers { ${animationStyle} visibility: hidden; opacity: 0; }
    .resize-triggers, .resize-triggers > div, .contract-trigger:before {
      content: ''; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;
    }
    .resize-triggers > div { background: #eee; overflow: auto; }
    .contract-trigger:before { width: 200%; height: 200%; }`,
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
}

/**
 * 重置的具体内容：使得每个滚动事件分发触发器的scrollTop/Left在最低部/右部
 * @method  resetTriggers
 * @author sansengg
 * @version 2017-03-16
 * @param   {[type]}      el 被绑定元素
 * @return  {[type]}         null
 */
function resetTriggers(el){
  const triggers = el._triggers,
    expand = triggers.firstElementChild,
    expandChild = expand.firstElementChild,
    contract = triggers.lastElementChild;

  contract.scrollLeft = contract.scrollWidth;
  contract.scrollTop = contract.scrollHeight;

  expandChild.style.height = expand.offsetHeight + 1 + 'px';
  expandChild.style.width = expand.offsetWidth + 1 + 'px';
  expand.scrollLeft = expand.scrollWidth;
  expand.scrollTop = expand.scrollHeight;
}

/**
 * 检测size是否发生变化
 * @method  checkResize
 * @author sansengg
 * @version 2017-03-16
 * @param   {[type]}    el [description]
 * @return  {[type]}       [description]
 */
function checkResize(el){
  return el._triggersLastSize.offsetWidth != el.offsetWidth || el._triggersLastSize.offsetHeight != el.offsetHeight;
}
/**
 * 监听滚动事件
 * @method  scrollListener
 * @author sansengg
 * @version 2017-03-16
 * @param   {[type]}       e [description]
 * @return  {[type]}         [description]
 */
function scrollListener(e){
  var el = this;

  if(checkResize(el)){
    cancelFrame(el._rafId);
    el._rafId = requestFrame(function(){
      resetTriggers(el);
      el._triggersLastSize = {
        offsetHeight: el.offsetHeight,
        offsetWidth: el.offsetWidth
      };
      el._resizeLiseners.forEach(function(fn){
        fn.call(el, e);
      });
    });
  }
}

export default {
  directiveName: 'resize',
  bind: function(el, binding, vnode){
    if(!isStyled){
      setStyle();
      isStyled = true;
    }
    var elPosition = getComputedStyle(el).position;
    if(elPosition == 'static' || elPosition == ''){
      el.style.position = 'relative';
    }
    let triggers = document.createElement('div');
    triggers.className = 'resize-triggers';
    triggers.innerHTML = `<div class="expand-trigger"><div></div></div>
    <div class="contract-trigger"></div>`;

    el.appendChild(triggers);
    el._triggers = triggers;
    el._resizeLiseners = [];
    el._triggersLastSize = {};
    el._rafId = null;
    // binding.def._triggers = triggers;
    if(Object.prototype.toString.call(binding.value).slice(8, -1) == 'Function'){
      el._resizeLiseners.push(binding.value)
    }
    el.addEventListener('scroll', scrollListener, true);
    // 监听 css,当重新显示时重置
    animationstartevent && triggers.addEventListener(animationstartevent, function(e){
      if(e.animationName == animationName){
        // 重置触发器
        resetTriggers(this);
      }
    });
  },
  inserted: function(el, binding, vnode){
    resetTriggers(el)
  },
  unbind: function(){
    // console.log('resize unbind');
  }
}



// WEBPACK FOOTER //
// ./src/directives/resize/src/resize.js